import React, { useEffect, useState } from "react";
import "./Banner.css";
import { Link, useNavigate } from "react-router-dom";
import Women from "./Animation/WomenLottie/Women";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import {
  faSearch,
  faMapMarker,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { Context } from "../../../../utils/context";
import Select from "react-select";
import Autosuggest from "react-autosuggest";

import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";
const Banner = () => {
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);
  const handleClick = () => {};
  const {
    getData,
    postData,
    recruiterData,
    setRecruiterData,
    Select2Skills,
    Select2Data,
    citySearch,
    setCitySearch,
    imageUrl,
  } = useContext(Context);
  const [selectCity, setSelectCity] = useState();
  const handleChange = async (e) => {
    if (e?.name === "city_id") {
      setSelectCity(e);
    }
  };
  const [industry_id, setSelectedIndustryOption] = useState("");
  const [suggestionsList, setSuggestionsList] = useState([]);

  const getSuggestions = async (inputValue, list) => {
    const inputValueLowerCase = (inputValue || "")?.trim()?.toLowerCase();

    console.log(inputValueLowerCase, "inputValueLowerCase");

    if (!inputValueLowerCase) return [];

    if (list === "industry_id") {
      const res = await getData(
        `/without-login/master/all-industry?name=${inputValueLowerCase}`,
      );
      if (res?.success) {
        return res.data?.filter((suggestion) =>
          suggestion?.name?.toLowerCase().includes(inputValueLowerCase),
        );
      }
    }
  };

  const onSuggestionsFetchRequested = async ({ value }, list) => {
    const suggestions = await getSuggestions(value, list);
    setSuggestionsList(suggestions);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestionsList([]);
  };

  const onChange = (event, { newValue }) => {
    if (event.target.id === "industry_id") {
      setSelectedIndustryOption(newValue || "");
    }
  };

  const getSuggestionValue = (suggestion) => suggestion?.name ?? "";

  const renderSuggestion = (suggestion, id) => (
    <div
      id={id}
      for={suggestion?.id}
      style={{
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
        margin: "5px",
        backgroundColor: "#f9f9f9",
      }}>
      {suggestion?.name}
    </div>
  );

  const inputProps = {
    onChange,
    style: {
      borderRadius: "5px",
      paddingLeft: "26px",
      backgroundColor: "#FBFBFB",
      border: "0px",
    },
  };

  const [cities, setCities] = useState();
  const getMasters = async () => {
    {
      const res = await getData(`/without-login/master/all-cities`);
      if (res?.success) {
        setCities(await Select2Data(res.data, "city_id"));
      }
    }
  };

  // const handleSearch = async () => {
  //   setCitySearch(selectCity);
  //   navigate(`/jobexp/${industry_id}`);
  // };

  const handleSearch = async () => {
    setCitySearch(selectCity);
    navigate(`/jobexp?id=${industry_id}&city_id=${selectCity.value}`);
  };

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    {
      const res = await commonBannerApi(BannersIDS.HPMainBanners);
      if (res?.success) {
        setImgSrc(res.data);
      }
    }
  };

  useEffect(() => {
    getMasters();
    getBanners();
  }, []);

  // const imgSrc = [
  //   "/assets/Images/home/banner/banner.png",
  //   "/assets/Images/home/banner/banner.png",
  // ];

  return (
    <>
      <section className="Banner homebannersec">
        <div className="banner_holder">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
            modules={[Pagination]}
            className="mySwiper">
            {imgSrc?.map((item) => {
              return (
                <SwiperSlide>
                  <div className="img_div">
                    <img src={imageUrl + item?.image} className="banner_img" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* <div className="banner_holder">
          <img
            src={
              process.env.PUBLIC_URL + "/assets/Images/home/banner/banner.png"
            }
            className="banner_img"
          />
        </div> */}

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-7 col-8 ">
              <div className="left-sec_banner">
                <h5 className="mt-lg-0 mt-md-0 mt-3 heading-one">
                  Find Jobs, Employement & Career Opportunities
                </h5>
                <div className="">
                  <p className="banner_heading_2">Drop a Portfolio & </p>

                  <p className="banner-heading-3">Get Your Desired Job!</p>
                </div>
                <p className="reach_text mb-lg-0 mb-md-0 mb-3">
                  <b className="inner_text">Reach 350 Million+ </b> job seekers
                  with a job posting on ECOHOUSE
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-4 pt-3">
              <Women />
            </div>
            <div className="col-xxl-8 col-xl-7 col-lg-8 col-md-12 col-12">
              <div className="row search_section mb-4">
                <div className="col-lg-12 ">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5">
                          <div className="btn-group searchJobs_section pe-0">
                            <FontAwesomeIcon
                              icon={faSearch}
                              className="search_icon_banner"
                            />
                            <Autosuggest
                              id="industry_id"
                              suggestions={suggestionsList}
                              onSuggestionsFetchRequested={(event) =>
                                onSuggestionsFetchRequested(
                                  event,
                                  "industry_id",
                                )
                              }
                              onSuggestionsClearRequested={
                                onSuggestionsClearRequested
                              }
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={(suggestion) =>
                                renderSuggestion(suggestion, "industry_id")
                              }
                              inputProps={{
                                ...inputProps,
                                id: "industry_id",
                                value: industry_id || "", 
                                placeholder: "Search Jobs",
                                className: "form-control search_icon_menu",
                              }}
                            />
                          </div>
                        </div>


                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-6 col-5 ps-0 ">
                          <div className="citiesDropdownBanner ">
                            <FontAwesomeIcon
                              icon="fa-solid fa-location-dot"
                              className="location_icon_banner"
                            />
                            <Select
                              classNamePrefix="custom-select"
                              name="city_id"
                              placeholder="All Cities"
                              value={selectCity}
                              onChange={handleChange}
                              options={cities}
                            />
                          </div>
                        </div>
                        
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-1 col-2 ps-0">
                          <div className="text-center ">
                            <button
                              className="btn  search_btn"
                              onClick={handleSearch}>
                              <span>Find Jobs</span>
                              <FontAwesomeIcon
                                icon="fa-solid fa-magnifying-glass"
                                className="seerachh-iccc"
                              />{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
